import * as React from 'react'

import { VisuallyHidden, Image } from '@thg-commerce/gravity-elements'
import { spacing, styled } from '@thg-commerce/enterprise-theme'

export interface GalleryItem {
  src: string
  alt: string
  visuallyHiddenText?: string
}

export interface GalleryThumbnailProps {
  active: boolean
  onClick?: () => void
  isAmp: boolean
  testId?: string
}

const ProxyButton = (
  props: React.ButtonHTMLAttributes<HTMLButtonElement> & {
    active: boolean
  },
) => {
  const { active, ...rest } = props
  return <button {...rest}>{props.children}</button>
}

const ThumbnailButton = styled(ProxyButton)<{
  on?: string
  active: boolean
}>`
  width: calc(100% / 3);
  margin: 0 ${spacing(1)};
  padding: 1px;
  border: 1px solid
    ${(props) =>
      props.active ? props.theme.colors.palette.brand.base : 'transparent'};

  &:hover {
    border-color: ${(props) =>
      props.active
        ? props.theme.colors.palette.brand.base
        : props.theme.colors.palette.greys.grey};
  }

  &:focus {
    border-width: 2px;
    border-color: ${(props) =>
      props.active
        ? props.theme.colors.palette.brand.base
        : props.theme.colors.palette.greys.grey};
    padding: 0;
    outline: none;
  }

  &:first-child {
    margin-left: 0;
  }

  &:last-child {
    margin-right: 0;
  }
`

const ThumbnailImage = styled(Image)`
  max-height: 76px;
`

export const GalleryThumbnail = (
  props: GalleryItem & GalleryThumbnailProps,
) => {
  return (
    <ThumbnailButton
      onClick={props.onClick}
      active={props.isAmp ? false : props.active}
      data-testid={props.testId}
    >
      {props.visuallyHiddenText && (
        <VisuallyHidden text={props.visuallyHiddenText} />
      )}
      <ThumbnailImage
        src={[{ url: props.src }]}
        width="100%"
        height="auto"
        alt={props.alt || ''}
        isAmp={false}
        imageStyle="cover"
      />
    </ThumbnailButton>
  )
}
